"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapUseRoutes = wrapUseRoutes;
const react_1 = require("react");
const startReactRouterView_1 = require("./startReactRouterView");
function wrapUseRoutes({ useRoutes, useLocation, matchRoutes, }) {
    return ((routes, locationArg) => {
        const location = useLocation();
        const pathname = typeof locationArg === 'string' ? locationArg : (locationArg === null || locationArg === void 0 ? void 0 : locationArg.pathname) || location.pathname;
        const pathnameRef = (0, react_1.useRef)(null);
        if (pathnameRef.current !== pathname) {
            pathnameRef.current = pathname;
            const matchedRoutes = matchRoutes(routes, pathname);
            if (matchedRoutes) {
                (0, startReactRouterView_1.startReactRouterView)(matchedRoutes);
            }
        }
        return useRoutes(routes, locationArg);
    });
}
//# sourceMappingURL=useRoutes.js.map